import { InMemoryCache } from '@apollo/client';
import { GET_ACCOUNT } from 'graphqls/profile';

export const initializeCurrentUser = (cache: InMemoryCache): void => {
  cache.writeQuery({
    query: GET_ACCOUNT,
    data: {},
  });
};

export default {
  defaults: {},
  resolvers: {
    Mutation: {
      setCurrentUser: (_, { currentUser }, { cache }): null => {
        cache.writeQuery({
          query: GET_ACCOUNT,
          data: {
            currentUser: {
              __typename: 'currentUser',
              ...currentUser,
            },
          },
        });

        return currentUser;
      },
    },
  },
};
